import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';
import split from 'lodash/split';
import { useAction } from 'hooks';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import FormGroup from 'components/Form/FormGroup';
import Link from 'components/Link';
import App from 'modules/App';
import Information from 'modules/Information';
import { AppContext } from 'context';
import { CONSENT_MODAL } from 'modules/Mobile/constants';
import { INFORMATION_FORM } from '../../constants';
import { getUrlWithLocale } from '../../components/SignUp/helpers';
const LegalConsentField = ({ legalConsent })=>{
    const { isAlpineEnabled } = useContext(AppContext);
    const locale = useSelector(App.selectors.langCode);
    const information = useSelector(Information.selectors.information);
    const localizationResources = useSelector(App.selectors.localizationResources);
    const formValues = useSelector(App.selectors.formSelector(INFORMATION_FORM));
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const setValue = useAction(App.actions.setFormValue, INFORMATION_FORM);
    const openModal = useAction(App.actions.openModal, CONSENT_MODAL);
    const setStaticFilesDir = useAction(App.actions.setStaticFilesDir);
    const onUrlClickHandler = (e, dir)=>{
        if (isAlpineEnabled === 'true') {
            setStaticFilesDir(dir);
            if (isMobileDisplayMode) {
                openModal();
                e.preventDefault();
            }
        }
    };
    const onSetValue = (input)=>{
        setValue({
            id: input.id,
            value: input.value || 'false'
        });
    };
    const { legalConsentApprovals } = information;
    const { legalConsentId, consentPromptKey, consentUrl, isMandatory } = legalConsent;
    let consentPrompt = get(localizationResources, [
        consentPromptKey,
        'value'
    ], '');
    if (consentPrompt && consentUrl) {
        const consentUrlWithLocale = getUrlWithLocale(consentUrl, locale);
        const strings = split(consentPrompt, /<[^>]+>/);
        const link = strings.length > 1 ? /*#__PURE__*/ _jsx(Link, {
            to: isAlpineEnabled === 'true' ? consentUrlWithLocale : consentUrl,
            target: "_blank",
            onClick: (e)=>onUrlClickHandler(e, App.constants.STATIC_FILES_SETTINGS.POLICY),
            children: strings[1]
        }) : null;
        consentPrompt = /*#__PURE__*/ _jsxs("span", {
            children: [
                strings[0],
                link,
                strings[2]
            ]
        });
    }
    const asterisk = isMandatory && !isMobileDisplayMode ? /*#__PURE__*/ _jsx("span", {
        children: "* "
    }) : '';
    const labelMessage = /*#__PURE__*/ _jsxs("span", {
        children: [
            asterisk,
            consentPrompt
        ]
    });
    const consentApproval = find(legalConsentApprovals, {
        legalConsentId
    });
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: `legalConsent-${legalConsentId}`,
        formValues: formValues,
        children: /*#__PURE__*/ _jsx(CheckboxRadio, {
            inputValue: "true",
            labelMessage: labelMessage,
            value: consentApproval ? consentApproval.decision : 'false',
            onChange: onSetValue
        })
    }, legalConsentId);
};
export default LegalConsentField;
